import {
	createAuthMiddleware,
	createUnauthorizedErrorMiddleware,
} from "@/lib/auth/api-middleware";
import { useAuth } from "@/lib/auth/auth-provider";
import { ApiClientContext } from "@/stores/api-client-store";
import { ApiClient } from "@jace/api";
import { env } from "env.mts";
import { type ReactNode, useEffect, useState } from "react";

export function ApiClientProvider({
	children,
}: {
	children: ReactNode;
}): React.ReactElement | null {
	const { getToken, signOut } = useAuth();
	const [client, setClient] = useState<ApiClient | null>(null);

	useEffect(() => {
		if (getToken) {
			setClient(
				new ApiClient(env.NEXT_PUBLIC_API_URL)
					.prefix("/api")
					.use(createAuthMiddleware(getToken, signOut))
					.use(createUnauthorizedErrorMiddleware(signOut)),
			);
		}
	}, [getToken]);

	if (!client) {
		return null;
	}

	return (
		<ApiClientContext.Provider value={{ client }}>
			{children}
		</ApiClientContext.Provider>
	);
}
